import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ISharedContentParams, ISharedFolderContentResponse, IUnreadResponse } from '../../models';
import { map, Observable } from 'rxjs';
import { getSharedContentQuery, getUnreadQuery, migrateDocumentsMutation } from '../../queries';

@Injectable()
export class SharedContentFacade {
  private readonly apollo = inject(Apollo);

  public getSharedContent(params: ISharedContentParams): Observable<ISharedFolderContentResponse> {
    return this.apollo
      .query<{ getSharedContent: ISharedFolderContentResponse }>({
        query: getSharedContentQuery,
        fetchPolicy: 'no-cache',
        variables: {
          input: {
            folderId: params.folderId,
            contractId: params.contractId,
            sortOrder: params.sortOrder,
            sortField: params.sortField,
          },
        },
      })
      .pipe(
        map(response => {
          if (response?.data?.getSharedContent) {
            return response?.data?.getSharedContent;
          } else {
            throw Error(response?.error?.message);
          }
        })
      );
  }

  public getUnread(): Observable<IUnreadResponse> {
    return this.apollo
      .query<{ getUnread: IUnreadResponse }>({
        query: getUnreadQuery,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        map(response => {
          if (response?.data?.getUnread) {
            return response.data.getUnread;
          } else {
            throw Error(response?.error?.message);
          }
        })
      );
  }

  public migrateDocuments(markAsRead: boolean): Observable<boolean> {
    return this.apollo
      .mutate<{ migrateDocuments: boolean }>({
        mutation: migrateDocumentsMutation,
        variables: {
          markAsRead,
        },
      })
      .pipe(
        map(response => {
          if (response?.data?.migrateDocuments !== undefined) {
            return response.data.migrateDocuments;
          } else {
            throw Error(response?.error?.[0]?.message);
          }
        })
      );
  }
}
